import React from 'react'

import { useRouter } from 'next/router'
import * as Env from 'env'

import { supported } from 'utils/mapbox'
import { UnsupportedMap, Screen } from 'layouts/pages'
import { Menu, Primary } from './drawers'
import { Provider as MenuProvider } from 'contexts/menu'
import { Provider as LayersProvider } from 'contexts/layers'
import { Provider as MapStateProvider } from 'contexts/map/state'
import MapLayout from './archive-map'
import { FooterDragHandle } from 'layouts/pages'
import { ArchiveWidget } from 'components/controls/ArchiveWidget/ArchiveWidget'
import { WarningModal } from 'components/controls/ArchiveWidget/WarningModal'
import { InfoBanner } from 'components/controls/ArchiveWidget/InfoBanner'
import { LoadingSpinner } from 'components/misc/LoadingSpinner/LoadingSpinner'
import { useLoadingArchivedForecasts } from 'hooks/useArchivedForecasts'
import { formatDateForQuery } from 'utils/product'

import './Map.module.css'

export default function Layout() {
    if (Env.server) {
        return <Screen />
    }

    if (!supported()) {
        return <UnsupportedMap />
    }

    return (
        <Screen footer={<FooterDragHandle />} isArchive>
            <WarningModal />
            <LayersProvider>
                <MenuProvider>
                    <MapStateProvider>
                        <MapLayout>
                            <Primary isArchive />
                        </MapLayout>
                        <InfoBanner />
                        <ArchiveWidget />
                        <Menu isArchive />
                        <Loading />
                    </MapStateProvider>
                </MenuProvider>
            </LayersProvider>
        </Screen>
    )
}

const Loading = () => {
    const { query } = useRouter()
    const { date } = query
    const formattedDate = formatDateForQuery(date)
    const { isLoading } = useLoadingArchivedForecasts(formattedDate)

    if (isLoading) {
        return (
            <div style={style.loading}>
                <LoadingSpinner />
            </div>
        )
    }
    return null
}

const style = {
    loading: {
        position: 'absolute',
        bottom: 30,
        left: 10,
        textShadow: '0 1px 2px rgba(0, 0, 0, 0.6)',
    },
}
